import React from "react";

interface ToggleProp {
  isChecked: boolean;
  onChange: Function;
}

function Toggle({ isChecked, onChange }: ToggleProp) {
  const clickToggle = () => {
    onChange(!isChecked);
  };

  return (
    <div className={"my-toggle" + (isChecked ? " on" : " off")} onClick={clickToggle}>
      <div className="my-toggle-btn"></div>
    </div>
  );
}

export default Toggle;
